import React from "react";

function Thankyou() {
  return (
    <div>
      <div className="py-3 bg-warning">
        <div className="container">
          <h6>ホーム / Thank you</h6>
        </div>
      </div>

      <div className="py-4">
        <div className="container">
          <div className="col-md-12">
            <div className="card text-center p-5">
              <h4>Swimming Pool Project</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Thankyou;
